import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { axiosPrivateInstance } from "../axios";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

export default function useAxiosPrivate() {
  const { accessToken, setAccessToken, csrftoken, user } = useAuth();
  const refresh = useRefreshToken();
  const setAlert = useSetRecoilState(AlertState);

  useEffect(() => {
    const requestIntercept = axiosPrivateInstance.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${accessToken}`;
          config.headers["X-CSRFToken"] = csrftoken;
          config.headers["Content-Type"] = "application/json";
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivateInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
          return;
        } else if (
          (error?.response?.status === 403 ||
            error?.response?.status === 401) &&
          !prevRequest?.sent
        ) {
          prevRequest.sent = true;
          try {
            const { csrfToken: newCSRFToken, accessToken: newAccessToken } =
              await refresh();
            setAccessToken(newAccessToken);
            prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            prevRequest.headers["X-CSRFToken"] = newCSRFToken;
            prevRequest.headers["Content-Type"] = "application/json";
            return axiosPrivateInstance(prevRequest);
          } catch (refreshError) {
            return Promise.reject(refreshError);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivateInstance.interceptors.request.eject(requestIntercept);
      axiosPrivateInstance.interceptors.response.eject(responseIntercept);
    };
  }, [accessToken, user]);

  return axiosPrivateInstance;
}
